// removed by extract-text-webpack-plugin
module.exports = {"container":"_2jKp9"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Navbar/NavbarChildren.less
// module id = 235
// module chunks = 0